import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "../pages/LoginPage";
import { isAdminAuthenticated } from "../../utils/auth";
import AdminList from "../components/AdminList/AdminList";
import Home from "../components/Home/Home.jsx"; // Include .jsx if necessary
import Lists from "../components/UserLists/UserLists.js";
import "./AdminRoute.scss";
import NotificationPage from "../components/FCM/NotificationPage.js";
import AdminLayout from "../layout/AdminLayout.js";
import RecomendedProducts from "../components/RecommendProducts/RecomendedProducts.js";
import ScheduleNotification from "../components/FCM/ScheduleNotification/ScheduleNotification.js";
import WeatherNotificationScheduler from "../components/FCM/AutomaticWeatherNotification/WeatherNotificationScheduler.js";
import ProfilePage from "../Profile/ProfilePage.js";
import CropStages from "../components/CropManagement/CropStages.js";
import FieldFetchPage from "../../users/components/PDFDocument/FieldFetchPage.js";
import CompanyPDFGeneratePage from "../../users/components/PDFDocument/CompanyPDFGeneratePage.js";

const AdminRoutes = () => {
  return (
    <Routes>
      {/* Redirect root admin path to either the dashboard or login */}
      <Route
        path="/"
        element={
          isAdminAuthenticated() ? (
            <Navigate to="/admin/dashboard" />
          ) : (
            <Navigate to="/admin/login" />
          )
        }
      />

      {/* Admin dashboard route */}
      <Route
        path="/dashboard"
        element={
          isAdminAuthenticated() ? <Home /> : <Navigate to="/admin/login" />
        }
      />
      <Route path="/all-admins">
        <Route index element={<Lists type="admins" />} />
      </Route>

      <Route path="/users" element={<Lists type="users" />} />
      <Route path="/crops" element={<Lists type="crops" />} />
      <Route path="/farms" element={<Lists type="farms" />} />

      <Route path="/all-users" element={<LoginPage />} />
      <Route path="/all-admins" element={<AdminList />} />
      <Route element={<AdminLayout />}>
        <Route path="/push-notification" element={<NotificationPage />} />
        <Route
          path="/schedule-notification"
          element={<ScheduleNotification />}
        />
        <Route
          path="/weather-notification"
          element={<WeatherNotificationScheduler />}
        />
        <Route
          path="/product-recommendation"
          element={<RecomendedProducts />}
        />
        <Route path="/admin-profile" element={<ProfilePage />} />
        <Route path="/crop-stage" element={<CropStages />} />
      </Route>
            <Route path="/company-generate-document" element={<FieldFetchPage />} />
            <Route path="/generate-report" element={<CompanyPDFGeneratePage />} />
      {/* Redirect to login for any unmatched route */}
      <Route path="*" element={<Navigate to="/admin/login" />} />
    </Routes>
  );
};

export default AdminRoutes;
